import dev, { isClient } from "../../utils/dev";
import { toObject } from "../../utils/utils";

export const loaded = (async () => {
  let iter = 0;
  return new Promise((res) => {
    if (!isClient) return res(false);

    const wait = () => {
      iter += 1;
      if (typeof window.fbq !== "undefined")
        console.log(`[FB] Loaded after ${iter} trials`) ?? res(true);
      else if (iter === 15)
        console.warn(`[FB] Not loaded after ${iter} trials`) ?? res(false);
      else setTimeout(wait, 100);
    };

    wait();
  });
})();

export const page = async (properties) => {
  isClient && dev.console.log("fb.pageView", properties, window.fbq);
  if (await loaded) {
    console.log("[FB] Track PageView");
    window.fbq("track", "PageView", toObject(properties));
  }
};

export const track = async (event, properties) => {
  isClient && dev.console.log("fb.trackCustom", properties, window.fbq);
  if (await loaded) {
    console.log("[FB] TrackCustom event");
    window.fbq("trackCustom", event, toObject(properties));
  }
};

export const init = async (pixel) => {
  isClient && dev.console.log("fb.init", pixel, window.fbq);
  if ((await loaded) && pixel) {
    console.log("[FB] Init pixel");
    window.fbq("init", `${pixel}`);
    window.fbq("track", "PageView");
  }
};
